// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"517bab32","766":"c25f600d","977":"8c35837e"}[chunkId] + ".chunk.js";
};